/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(e){return e instanceof SVGElement&&"svg"!==e.tagName}export{e as isSVGElement};
//# sourceMappingURL=is-svg-element.js.map
